import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import RaitingTile from "./RaitingTile";

interface FeedbackProps {
  ratingState: number;
  setRatingState: any;
  goToRequestCallout: any;
}

/*
const labels = {
  1: "Useless",
  2: "Useless+",
  3: "Poor",
  4: "Poor+",
  5: "Ok",
  6: "Ok+",
  7: "Good",
  8: "Good+",
  9: "Excellent",
  10: "Excellent+",
};
*/

let labels: { [key: number]: string } = {
    1: "Useless",
    2: "Useless+",
    3: "Poor",
    4: "Poor+",
    5: "Ok",
    6: "Ok+",
    7: "Good",
    8: "Good+",
    9: "Excellent",
    10: "Excellent+"
}

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#001234",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    padding: "20px 0",
  },
  label: {
    fontSize: 26,
    fontWeight: 700,
    fontFamily: "lato",
    color: "white",

    "@media (max-width: 600px)": {
      fontSize: 17,
      maxWidth: 310,
      lineHeight: "29px",
    },
    "@media (max-width: 1024px)": {
      fontSize: 20,
    },
  },
  labelBox: {
    background: "rgba(255, 255, 255, .1)",
    borderRadius: 37.5,
    padding: "7px 25px 11px 33px",
    marginBottom: 35,

    "@media (max-width: 600px)": {
      marginBottom: 16,
    },
    "@media (max-width: 1024px)": {
      marginBottom: 24,
    },
  },
  ratingContainer: {
    marginTop: 20,
    "@media (max-width: 600px)": {
      display: "none",
    },
  },
  mobileRatingContainer: {
    marginTop: 20,
    display: "flex",

    "@media (min-width: 600px)": {
      display: "none",
    },
  },
  ratingTextContainer: {
    display: "flex",
    justifyContent: "space-between",
    color: "white",
    marginTop: 9,
  },
  ratingText: {
    fontSize: 21,
    fontWeight: 400,
    fontFamily: "lato",
    color: "white",
    opacity: 0.51,
  },
  ratingMobileText: {
    fontSize: 21,
    color: "#fff",
    margin: "3px 0 0 17px",
  },
}));

const ratingArray = [...Array(11).keys()];

const Feedback: React.FC<FeedbackProps> = ({ ratingState, setRatingState, goToRequestCallout }) => {
  React.useEffect(() => {
    let timerGoBack = setTimeout(() => goToRequestCallout(), 20 * 60 * 1000);
    return () => {
      clearTimeout(timerGoBack);
    };
  }, []);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.labelBox}>
        <div className={classes.label}>Thanks for using SMA.</div>
      </div>
      <div className={classes.label}>How likely would you be to recommend SMA to a friend or colleague?</div>
      <div className={classes.ratingContainer}>
        <div>
          {ratingArray.map((el) => (
            <RaitingTile value={el} key={el} ratingState={ratingState} setRatingState={setRatingState} />
          ))}
        </div>
        <div className={classes.ratingTextContainer}>
          <div className={classes.ratingText}>Not at all likely</div>
          <div className={classes.ratingText}>Very likely</div>
        </div>
      </div>
      <div className={classes.mobileRatingContainer}>
        <Rating
          name="simple-controlled"
          value={ratingState / 2}
          onChange={(event, newValue) => {
            setRatingState(newValue ? newValue * 2 : -1); // conversion from 5 stars to 10
          }}
          precision={0.5}
        />

        <span className={classes.ratingMobileText}>{ratingState > 0 && labels[ratingState ?? 0]}</span>
      </div>
    </div>
  );
};

export default Feedback;
